import React from 'react';
import './back-to-banner.scss';
import { Container, Link } from '@material-ui/core';
import { ChevronLeftOutlinedIcon } from 'components/icons/chevron-left-outlined';
import { BackToBannerProps } from './back-to-banner-props';

/**
 * A banner that allows navigating back.
 *
 * This does not function as a browser back, instead it is treated
 * as a new link, adding the page to the browser history stack.
 * @param props
 */
export const BackToBanner: React.FC<BackToBannerProps> = (props) => {
  const {
    href = '../',
    linkProps,
    children,
  } = props;

  return (
    <div className="sg-back-to-banner">
      <Container>
        <Link
          {...linkProps}
          className="back-to__link"
          href={href}
        >
          <ChevronLeftOutlinedIcon fontSize="small" />{children}
        </Link>
      </Container>
    </div>
  );
};
